export interface CreateRequestSchoolCandidate {
    requestId: number;
    uoguCountyId: number;
    institutionId?: number;
    requestSchoolCandidateCreateType: RequestSchoolCandidateCreateType;
}

export enum RequestSchoolCandidateCreateType
{
    County = 1,
    Institution = 2,
}
